import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePlus } from "@fortawesome/pro-regular-svg-icons";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import { toast } from "react-toastify";

const BulkSkuUploader = ({
  onSkusAdded,
  existingSkus = [],
  disabled = false,
  limitToTen = false,
}) => {
  const fileInputRef = useRef(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file || disabled) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      const lines = content.split("\n");
      const newSkus = [];

      lines.forEach((line) => {
        // Handle both CSV and TSV formats
        const sku = line.trim().split(/[,\t]/)[0]; // Split by comma or tab, take first column
        if (sku && sku.length > 0) {
          newSkus.push(sku);
        }
      });

      // Add new SKUs to existing ones, avoiding duplicates
      const existingSkusFiltered = existingSkus.filter(
        (sku) => sku.trim() !== ""
      );
      const allSkus = [...existingSkusFiltered, ...newSkus];
      const uniqueSkus = [...new Set(allSkus)];

      if (limitToTen) {
        // Limit to maximum 10 SKUs
        const limitedSkus = uniqueSkus.slice(0, 10);

        // Show warning if SKUs were truncated
        if (uniqueSkus.length > 10) {
          const ignoredSkus = uniqueSkus.slice(10);

          toast.warning(
            <div>
              The following SKUs could not be added:
              <br />
              {ignoredSkus.map((sku, index) => (
                <div key={index}>• {sku}</div>
              ))}
            </div>
          );
        }

        onSkusAdded(limitedSkus);
      } else {
        onSkusAdded(uniqueSkus);
      }
    };

    reader.readAsText(file);

    // Reset the file input
    event.target.value = "";
  };

  return (
    <>
      {/* Hidden file input */}
      <input
        type="file"
        ref={fileInputRef}
        accept=".csv,.tsv,.txt"
        onChange={handleFileUpload}
        style={{ display: "none" }}
      />

      <button
        className="btn btn-sm btn-secondary w-100"
        onClick={(e) => {
          e.preventDefault();
          if (!disabled) {
            fileInputRef.current.click();
          }
        }}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={faFilePlus} className="mr-2" /> Bulk Add SKUs
      </button>
      {limitToTen && (
        <p className="text-sm text-brand-grey-200">
          <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon> Max. Products:
          10
        </p>
      )}
    </>
  );
};

export default BulkSkuUploader;
